var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "de-tabs-div", class: _vm.headClass },
    [
      _vm.maskShow
        ? _c("div", { staticClass: "frame-mask edit-mask" })
        : _vm._e(),
      _c(
        "dataease-tabs",
        {
          staticClass: "de-tabs-height",
          class: _vm.isCurrentEdit ? "de-tabs-edit" : "",
          attrs: {
            type: "card",
            "style-type": "radioGroup",
            "font-color": _vm.fontColor,
            "active-color": _vm.activeColor,
            "border-color": _vm.borderColor,
            "border-active-color": _vm.borderActiveColor,
            addable: _vm.isEdit && !_vm.mobileLayoutStatus,
          },
          on: { "tab-add": _vm.addTab, "tab-click": _vm.handleClick },
          model: {
            value: _vm.activeTabName,
            callback: function ($$v) {
              _vm.activeTabName = $$v
            },
            expression: "activeTabName",
          },
        },
        _vm._l(_vm.element.options.tabList, function (item, index) {
          return _c(
            "el-tab-pane",
            { key: item.name + index, attrs: { lazy: false, name: item.name } },
            [
              _c(
                "span",
                { attrs: { slot: "label" }, slot: "label" },
                [
                  _c("span", { style: _vm.titleStyle(item.name) }, [
                    _vm._v(_vm._s(item.title)),
                  ]),
                  _vm.dropdownShow
                    ? _c(
                        "el-dropdown",
                        {
                          staticClass: "de-tab-drop",
                          attrs: { slot: "label", trigger: "click" },
                          on: { command: _vm.handleCommand },
                          slot: "label",
                        },
                        [
                          _c("span", { staticClass: "el-dropdown-link" }, [
                            _vm.isEdit
                              ? _c("i", {
                                  staticClass:
                                    "de-tab-i el-icon-arrow-down el-icon--right",
                                })
                              : _vm._e(),
                          ]),
                          _c(
                            "el-dropdown-menu",
                            { attrs: { slot: "dropdown" }, slot: "dropdown" },
                            [
                              _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    command: _vm.beforeHandleCommand(
                                      "editTitle",
                                      item
                                    ),
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("detabs.eidttitle")) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm.element.options.tabList.length > 1
                                ? _c(
                                    "el-dropdown-item",
                                    {
                                      attrs: {
                                        command: _vm.beforeHandleCommand(
                                          "deleteCur",
                                          item
                                        ),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.$t("table.delete")) +
                                          "\n            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              item.content &&
              item.content.type === "canvas" &&
              _vm.isEdit &&
              !_vm.mobileLayoutStatus
                ? _c("de-canvas-tab", {
                    ref: "canvasTabRef-" + item.name,
                    refInFor: true,
                    staticClass: "tab_canvas",
                    class: _vm.moveActive ? "canvas_move_in" : "",
                    attrs: {
                      "parent-forbid": true,
                      "canvas-style-data": _vm.canvasStyleData,
                      "component-data": _vm.tabCanvasComponentData(item.name),
                      "canvas-id": _vm.element.id + "-" + item.name,
                    },
                    on: { canvasScroll: _vm.canvasScroll },
                  })
                : _vm._e(),
              item.content &&
              item.content.type === "canvas" &&
              (!_vm.isEdit || _vm.mobileLayoutStatus)
                ? _c(
                    "div",
                    { staticStyle: { width: "100%", height: "100%" } },
                    [
                      _c("Preview", {
                        ref: "canvasTabRef-" + item.name,
                        refInFor: true,
                        attrs: {
                          "component-data": _vm.tabCanvasComponentData(
                            item.name
                          ),
                          "canvas-style-data": _vm.canvasStyleData,
                          "canvas-id": _vm.element.id + "-" + item.name,
                          "panel-info": _vm.panelInfo,
                          "in-screen": _vm.inScreen,
                          "show-position": _vm.showPosition,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              item.content && item.content.type !== "view"
                ? _c(item.content.component, {
                    ref: item.name,
                    refInFor: true,
                    tag: "component",
                    attrs: {
                      "in-tab": true,
                      "is-edit": _vm.isEdit,
                      active: _vm.active,
                      element: item.content,
                      filters:
                        _vm.filterMap[
                          item.content.propValue &&
                            item.content.propValue.viewId
                        ] || [],
                      "out-style": _vm.outStyle,
                      "edit-mode": _vm.editMode,
                      h: _vm.tabH,
                    },
                  })
                : _vm._e(),
              _c(
                "div",
                { staticClass: "de-tab-content" },
                [
                  item.content &&
                  item.content.type === "view" &&
                  item.content.propValue &&
                  item.content.propValue.viewId
                    ? _c("user-view", {
                        ref: item.name,
                        refInFor: true,
                        attrs: {
                          "in-tab": true,
                          "is-edit": _vm.isEdit,
                          active: _vm.active,
                          element: item.content,
                          filters:
                            _vm.filterMap[
                              item.content.propValue &&
                                item.content.propValue.viewId
                            ] || [],
                          "out-style": _vm.outStyle,
                          "canvas-style-data": _vm.canvasStyleData,
                          "show-position": _vm.showPosition,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        }),
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("detabs.eidttitle"),
            "append-to-body": true,
            visible: _vm.dialogVisible,
            width: "30%",
            "show-close": false,
            "close-on-click-modal": false,
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("el-input", {
            attrs: {
              type: "textarea",
              rows: 2,
              maxlength: "10",
              "show-word-limit": "",
              placeholder: _vm.$t("dataset.input_content"),
            },
            model: {
              value: _vm.textarea,
              callback: function ($$v) {
                _vm.textarea = $$v
              },
              expression: "textarea",
            },
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("table.cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { disabled: !_vm.titleValid, type: "primary" },
                  on: { click: _vm.sureCurTitle },
                },
                [_vm._v(_vm._s(_vm.$t("table.confirm")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("detabs.selectview"),
            "append-to-body": true,
            visible: _vm.viewDialogVisible,
            width: "20%",
            height: "400px",
            "show-close": false,
            "close-on-click-modal": false,
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.viewDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                width: "100%",
                "min-height": "250px",
                "max-height": "300px",
                "overflow-y": "auto",
              },
            },
            [
              _vm.viewDialogVisible
                ? _c("view-select", {
                    ref: "viewSelect",
                    attrs: { "select-model": true },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.viewDialogVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("table.cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.sureViewSelector },
                },
                [_vm._v(_vm._s(_vm.$t("table.confirm")))]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("detabs.availableComponents"),
            "append-to-body": true,
            visible: _vm.otherComponentDialogVisible,
            width: "300px",
            height: "250px",
            "show-close": false,
            "close-on-click-modal": false,
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.otherComponentDialogVisible = $event
            },
          },
        },
        [
          _vm.otherComponentDialogVisible
            ? _c("tab-use-list", { ref: "otherComponentSelect" })
            : _vm._e(),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.otherComponentDialogVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("table.cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.sureOtherComponentSelector },
                },
                [_vm._v(_vm._s(_vm.$t("table.confirm")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.showAttr &&
      _vm.curComponent.canvasId === _vm.activeCanvasId &&
      _vm.isEdit
        ? _c("text-attr", {
            attrs: {
              "canvas-id": _vm.curComponent.canvasId,
              "scroll-left": _vm.scrollLeft,
              "scroll-top": _vm.scrollTop,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }